var _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEmail2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_142)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 29.1666H25",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 45.8334H20.8333",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5833 36.6708L35.0833 61.6708C34.9675 62.8293 35.0957 63.9992 35.4597 65.1051C35.8236 66.211 36.4153 67.2283 37.1965 68.0916C37.9777 68.9548 38.9311 69.6448 39.9953 70.117C41.0594 70.5893 42.2108 70.8333 43.375 70.8333H76.625C78.6915 70.8332 80.6843 70.0653 82.2165 68.6786C83.7487 67.2919 84.7111 65.3854 84.9167 63.3291L87.4167 38.3291C87.5325 37.1707 87.4043 36.0008 87.0404 34.8949C86.6764 33.789 86.0848 32.7716 85.3036 31.9084C84.5224 31.0451 83.5689 30.3551 82.5048 29.8829C81.4406 29.4107 80.2893 29.1667 79.125 29.1666H45.875C43.8085 29.1667 41.8157 29.9346 40.2835 31.3213C38.7513 32.708 37.789 34.6145 37.5833 36.6708Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8333 31.25L62.4999 50L84.5833 33.3333",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_142"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmail2);
export default __webpack_public_path__ + "static/media/icon-email-2.061960c769eb75007aac068adb824f23.svg";
export { ForwardRef as ReactComponent };